export default "__VITE_ASSET__BhJPjm5N__"